export const ROOT_PAGES = <const>['wallet', 'orders']
